import * as React from 'react';
import styled from 'styled-components';

/**
 * Input label or legend
 *
 * @extends React.ComponentPropsWithoutRef<'label'> @see React.ComponentPropsWithoutRef
 * @extends React.ComponentPropsWithoutRef<'legend'> @see React.ComponentPropsWithoutRef
 *
 * @member htmlFor, html property for [required if not a legend]
 * @member labelIsLegend if the label should be a <legend> instead of a <label> (in case of a multi-input usually)
 */
export interface JRCFormLabelProps extends React.ComponentPropsWithoutRef<'label'> {
    htmlFor?: string;
    labelIsLegend?: boolean;
    sideMargin?: string | undefined;
}

const StyledLabel = styled.label<{ sideMargin?: string | undefined }>`
    margin-left: ${({ sideMargin }) => sideMargin || '0px'};
    margin-right: ${({ sideMargin }) => sideMargin || '0px'};
    margin-bottom: 8px;
    font-size: 14px;
    width: 100%;
    min-height: 20px;
`;

const StyledLegend = styled.legend<{ sideMargin?: string | undefined }>`
    margin-left: ${({ sideMargin }) => sideMargin || '0px'};
    margin-left: ${({ sideMargin }) => sideMargin || '0px'};
    margin-bottom: 4px;
    line-height: 1.25;
    font-size: 14px;
`;

const FormLabel = (props: JRCFormLabelProps) =>
    props.labelIsLegend ? (
        <StyledLegend sideMargin={props.sideMargin}>{props.children}</StyledLegend>
    ) : (
        <StyledLabel htmlFor={props.htmlFor} sideMargin={props.sideMargin}>
            {props.children}
        </StyledLabel>
    );
export default FormLabel;
